// extracted by mini-css-extract-plugin
export default {"container":"NoResults_container__ddCzV","title":"NoResults_title__u7axU","description":"NoResults_description__DUHjl"};